import IVehicleType from '../Types/IVehicleType';
import {IGenericObject} from '../Types/IGenericObject';
import VehicleGroupLabel from '../Enum/VehicleGroupLabel';

const VEHICLE_TYPES: IVehicleType[] = [
    {
        label: VehicleGroupLabel.CAR,
        type: 'Car'
    },
    {
        label: VehicleGroupLabel.SUV_WAGON,
        type: 'SUV,Wagon'
    },
    {
        label: VehicleGroupLabel.PASSENGERVAN_MONOSPACE,
        type: 'PassengerVan'
    },
    {
        label: VehicleGroupLabel.COUPE_CONVERTIBLE_SPORT,
        type: 'Coupe,Convertible,Sport'
    },
    {
        label: VehicleGroupLabel.PICKUP_UTE,
        type: 'Pickup,Ute'
    },
    {
        label: VehicleGroupLabel.COMMERCIAL_VAN_TRUCK,
        type: 'CommercialVan,Truck'
    }
];

export const VEHICLE_GROUP_MAP: IGenericObject = {
    "Convertible": VehicleGroupLabel.COUPE_CONVERTIBLE_SPORT,
    "Station Wagon": VehicleGroupLabel.SUV_WAGON,
    "Pickup": VehicleGroupLabel.PICKUP_UTE,
    "Sports car": VehicleGroupLabel.COUPE_CONVERTIBLE_SPORT,
    "SUV": VehicleGroupLabel.SUV_WAGON,
    "Van": VehicleGroupLabel.PASSENGERVAN_MONOSPACE,
    "Wagon/Estate": VehicleGroupLabel.SUV_WAGON,
    "Passenger Van": VehicleGroupLabel.PASSENGERVAN_MONOSPACE,
    "Sport": VehicleGroupLabel.COUPE_CONVERTIBLE_SPORT,
    "Open Air All Terrain": VehicleGroupLabel.SUV_WAGON,
    "Pick up Regular Cab": VehicleGroupLabel.PICKUP_UTE,
    "Pick up Extended Cab": VehicleGroupLabel.PICKUP_UTE,
    "Coupe": VehicleGroupLabel.COUPE_CONVERTIBLE_SPORT,
    "Monospace": VehicleGroupLabel.PASSENGERVAN_MONOSPACE,
    "Car": VehicleGroupLabel.CAR,
    "Commercial Van/Truck": VehicleGroupLabel.COMMERCIAL_VAN_TRUCK
}

export const VEHICLE_TYPES_TOTAL: number = Object.keys(VEHICLE_TYPES).length;

export default VEHICLE_TYPES;
